import { render, staticRenderFns } from "./PopupSignedDocumentList.vue?vue&type=template&id=52474f14&scoped=true"
import script from "./PopupSignedDocumentList.vue?vue&type=script&lang=js"
export * from "./PopupSignedDocumentList.vue?vue&type=script&lang=js"
import style0 from "./PopupSignedDocumentList.vue?vue&type=style&index=0&id=52474f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52474f14",
  null
  
)

export default component.exports